import i18next from "i18next";
import React, { useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import { languageMapping } from "../../../../i18n/config";
import { useDisclosure, Box } from "@chakra-ui/react";
import GameMarqueeModal from "./GameMarqueeModal";
import GameMarqueeIconButton from "./GameMarqueeIconButton";
import { useParams } from "react-router-dom";
import Cookies from "js-cookie";

const GameMarquee = ({ gameConfig } = {}) => {
  const gameMarqueeList = useSelector((state) => state.isGameMarqueeList);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { gameUid } = useParams();

  const gameMarquee = useMemo(() => {
    return gameMarqueeList.filter((item) => {
      const currentLng = languageMapping(i18next.language) || "en_US";
      const uid = Number(gameUid);
      const data = item[currentLng] || item; // Fallback
      return data && data.game_uids && data.game_uids.includes(uid);
    });
  }, [gameMarqueeList, gameUid]);

  const isExist = useMemo(() => gameMarquee?.length > 0, [gameMarquee]);

  useEffect(() => {
    if (isExist) {
      const currentLng = languageMapping(i18next.language) || "en_US";
      const shouldShow = gameMarquee.some((item) => {
        const data = item[currentLng] || item;
        if (data && data.marquee_id) {
          return Cookies.get(`hide_game_marquee_${data.marquee_id}`) !== "true";
        }
        return true;
      });

      if (shouldShow) {
        onOpen();
      }
    }
  }, [isExist, gameMarquee, onOpen]);

  if (!isExist) return null;

  return (
    <Box position="absolute" top={0} right={0} zIndex={100}>
      <GameMarqueeIconButton onClick={onOpen} />
      <GameMarqueeModal
        isOpen={isOpen}
        onClose={onClose}
        gameMarquee={gameMarquee}
      />
    </Box>
  );
};

export default GameMarquee;
